import axiosInstance from './axios';

export const sliderService = {
  getSliders: async (params = {}) => {
    const response = await axiosInstance.get('/sliders', { params });
    return response.data;
  },

  getSlider: async (id) => {
    const response = await axiosInstance.get(`/sliders/${id}`);
    return response.data;
  },

  createSlider: async (sliderData) => {
    const response = await axiosInstance.post('/sliders', sliderData);
    return response.data;
  },

  updateSlider: async (id, sliderData) => {
    const response = await axiosInstance.put(`/sliders/${id}`, sliderData);
    return response.data;
  },

  deleteSlider: async (id) => {
    const response = await axiosInstance.delete(`/sliders/${id}`);
    return response.data;
  },
};
